// extracted by mini-css-extract-plugin
module.exports = {"marginTop":"dog_marginTop__1cRSB","div":"dog_div__2uCZa","img":"dog_img__DZojX","dogname":"dog_dogname__26Inj","more":"dog_more__MOXnu"};